import { Box, Button } from '@mui/material';
import React, { useContext } from 'react';
import SnackbarManager from '../../../utils/SnackbarManager';
import { BookingStore } from '../../../utils/stores/BookingStore';

const stepperSx = {
    stepperButtons: {
        mt: '20px',
        mb: '15px',
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        zIndex: 10,
        height: 54,
        '& .MuiButton-root': {
            width: 120,
            maxWidth: '23%',
        },
    },
} as const;

export default function StepperButtons({ numberOfSteps }) {
    const bookingController = useContext(BookingStore);

    const handleNext = () => {
        bookingController.checkFormErrors(bookingController.step)
            ? SnackbarManager.warning('Please check the form fields')
            : bookingController.nextStep();
    };

    return (
        <Box sx={stepperSx.stepperButtons}>
            <Button
                onClick={bookingController.prevStep}
                variant="outlined"
                color="primary"
                disabled={bookingController.step === 0}
            >
                Prev
            </Button>
            <Button
                onClick={() => handleNext()}
                variant="contained"
                color="primary"
                disabled={bookingController.step === numberOfSteps - 1}
            >
                Next
            </Button>
        </Box>
    );
}
